import { Injectable } from '@angular/core';
import { ServiceService } from './service.service';

@Injectable({
  providedIn: 'root'
})
export class PqsAdminService {

  constructor(private servi: ServiceService) { }


  getListado() { return this.servi.get('PQRS/GetListado'); }
  getDetalle(id:any) { return this.servi.get('PQRS/getDetalle/'+id); }
  getListadoHistorial() { return this.servi.get('PQRS/getListadoHistorial'); }

  asignarUnidad(data) { return this.servi.post('PQRS/AsignarUnidad', data); }

  rechazarSolicitud(data) { return this.servi.post('PQRS/RechazarSolicitud', data); }

  public responderSolicitud(data) { 
    const formData = new FormData();
    for ( const nombre in data ) {
      if (data[nombre]) {
          formData.append(nombre, data[nombre]);
      }
    }
    return this.servi.postFile(`PQRS/ResponderSolicitud`, formData); 
  }

  public editarSolicitud(data) { return this.servi.post(`PQRS/EditarSolicitudPQRS`, data); }

  getServe() { return this.servi.server; }

}
